function GetCurrentTimestamp() {
    return new Date().getTime();
}
export default GetCurrentTimestamp;   